"use strict";

import { customAlphabet } from "nanoid";

// NOTE: 기본 nanoid 문자셋(A-Za-z0-9_-)의 '_'·'-'는 id를 이어 붙이는 구분자로 쓰여(폴더트리 code, 이벤트 트리거 key 등) split 시 조각이 어긋난다. 영숫자만 사용한다.
export const createId = customAlphabet("0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ", 21);

const uniqueId = function() {
    return `${Math.floor(new Date().getTime() / 1000)}${createId()}`;
}

export default uniqueId;
